import "./new-employee-diciplinary.scss";

import { useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { FieldErrors, FormProvider, useForm } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";
import { Button } from "primereact/button";

import { MessageResponseDto } from "@api/api";
import { useFormApiMapper } from "@core/services/form-api-mapper.hook";
import { useQyCreateEmployeeDiciplinary } from "@core/query/employee-diciplinary.query";
import {
  EmployeeDiciplinaryFormRule,
  EmployeeDiciplinaryFormSchema,
} from "@core/form/form.rule";
import { employeeDiciplinaryFormDefault } from "@core/form/form.default";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import HeaderContent from "@shared/ui/header-content/header-content";
import FormEmployeeDiciplinary from "../form-employee-diciplinary/form-employee-diciplinary";
import { useFormDropdownPersonContext } from "@domain/person/form-dropdown-person/form-dropdown-person.context";

export function NewEmployeeDiciplinary() {
  // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateEmployeeDiciplinary } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();
  const { selectedPersonData } = useFormDropdownPersonContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New Employee Disciplinary is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addEmployeeDiciplinary, isLoading: isCreating } =
    useQyCreateEmployeeDiciplinary(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<EmployeeDiciplinaryFormSchema>({
    defaultValues: employeeDiciplinaryFormDefault,
    resolver: zodResolver(EmployeeDiciplinaryFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: EmployeeDiciplinaryFormSchema) => {
    const defaultFormData = {
      userCode: selectedPersonData?.code,
      bucketCode: selectedPersonData?.bucket.code,
      branchCode: selectedPersonData?.bucket.branch,
    };

    const updatedForm = {
      ...form,
      userCode: defaultFormData.userCode,
      bucketCode: defaultFormData.bucketCode,
      branchCode: defaultFormData.branchCode,
    } as EmployeeDiciplinaryFormSchema;
    const formData = mapCreateEmployeeDiciplinary(updatedForm);
    addEmployeeDiciplinary(formData);
  };
  const handleValidateError = (
    err: FieldErrors<EmployeeDiciplinaryFormSchema>
  ) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return (
    <div id="EmployeeDiciplinary" className="employee-diciplinary">
      <HeaderContent
        title="New Employee Disciplinary"
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4 bg-white">
            <FormEmployeeDiciplinary />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewEmployeeDiciplinary;
